import { Component, OnInit, EventEmitter } from '@angular/core';
import { DialogComponent, DialogService } from "ng2-bootstrap-modal";
import { TwitterService } from '../../../_services/twitter.service';
import { ElementRef, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from "@angular/forms";

@Component({
    selector: 'app-add-twitter',
    templateUrl: './add-twitter.component.html',
    styleUrls: ['./add-twitter.component.css']
})
export class AddTwitterComponent extends DialogComponent<null, boolean> implements OnInit {
    loading = false;
    showMsg = false;
    messages = '';

    @ViewChild('fileInput') fileInput: ElementRef;
    focusEventEmitter = new EventEmitter<boolean>();

    constructor(
        dialogService: DialogService,
        private twitterService: TwitterService,
        private fb: FormBuilder,
    ) {
        super(dialogService);
    }

    ngOnInit() { }

    onSubmit(FormTwitter) {
        this.loading = true;
        let model = FormTwitter.value;
        this.twitterService.add(model).subscribe(
            data => {
                this.loading = false;
                if (data.messages != 'success') {
                    this.messages = data.messages;
                    this.showMsg = true;
                } else {
                    //close modal
                    this.close();
                }
            }, error => {
                this.close();
            }
        );
    }

}



// WEBPACK FOOTER //
// C:/Users/El-Nino/Desktop/coin-alert-test/AngularCoinAlert/src/app/_components/twitter/add-twitter/add-twitter.component.ts